import { fmtInt } from "@/lib/api";
import { btwScenarioRows, BTW_ESTIMATE_NOTE, BTW_MIXED_NOTE } from "@/lib/btw";

// Scenario-rapport: informatief BTW-blok per projectiejaar (alleen BTW-plichtige clubs).
export function BtwStrip({ t, years, regime = "plichtig" }) {
  if (!years?.length) return null;
  const rows = btwScenarioRows(regime);
  return (
    <div className="bg-card border-2 border-foreground heavy-shadow mt-6 mb-10" data-testid="btw-strip">
      <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-foreground text-background">
            <th className="text-left px-3 py-2 font-display uppercase text-xs tracking-widest sticky left-0 bg-foreground w-64">
              {t("BTW")}
              <span className="normal-case tracking-normal font-normal opacity-70 text-[10px] ml-2">{t(regime === "gemengd" ? "schatting · niet-aftrekbaar deel telt als kostenpost · bedragen excl. BTW" : "schatting · informatief · bedragen excl. BTW")}</span>
            </th>
            {years.map((y) => (
              <th key={y.year} className="text-right px-3 py-2 font-display uppercase text-xs tracking-widest whitespace-nowrap">{y.actual_year}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map(([key, label]) => {
            const saldo = key === "vat_balance";
            const sub = key === "vat_opex_deductible" || key === "vat_capex_nondeductible";
            const isPct = key === "pro_rata_pct";
            return (
              <tr key={key} className={saldo ? "border-t-2 border-foreground bg-muted/40" : "border-b border-foreground/10"} data-testid={`btw-strip-row-${key}`}>
                <td className={`px-3 py-1.5 sticky left-0 ${saldo ? "sticky-tint-40 font-display uppercase font-black" : sub ? "bg-card pl-8 italic text-muted-foreground" : "bg-card"}`}>{t(label)}</td>
                {years.map((y) => {
                  const v = y[key] || 0;
                  return (
                    <td key={y.year} data-testid={`btw-strip-${key}-${y.actual_year}`}
                      className={`text-right px-3 py-1.5 font-mono-num whitespace-nowrap ${saldo ? "font-bold" : ""} ${sub ? "text-muted-foreground" : ""}`}>
                      {isPct ? `${Number(v).toLocaleString("nl-NL", { maximumFractionDigits: 1 })} %` : saldo ? `${v > 0 ? "+" : v < 0 ? "−" : ""}${fmtInt(Math.abs(v))}` : fmtInt(v)}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      </div>
      <p className="px-3 py-2 text-[11px] text-muted-foreground border-t border-foreground/10">
        {t(regime === "gemengd" ? BTW_MIXED_NOTE : BTW_ESTIMATE_NOTE)}
      </p>
    </div>
  );
}
